import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import Table from '../../table/Table';
import Button from '../../forms/Button';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Select from '../../forms/Select';

function PointsAwards() {
    const [awards, setAwards] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.LoyaltyPointAwards.main)
            .then(data => setAwards(data))
            .catch(() => setAwards([]));
    }, []);

    const refreshAwards = () => {
        HamQuest.get(QuestRoute.LoyaltyPointAwards.main)
            .then(data => setAwards(data))
            .catch(() => setAwards([]));
    };

    const AwardForm = ({ values }) => (
        <>
            <Input
                label="Description"
                name="Description"
                value={values.Description}
                required
            />
            <Input
                label="Points"
                name="pointCost"
                type="number"
                value={values.pointCost}
                required
            />
            <Select
                label="App Product"
                name="appProductId"
                getOptions={QuestRoute.products.all}
                buildOptions={e => {
                    e.label = e.name;
                    e.value = e.appProductId;
                }}
                nullable
            />
            <Select
                label="App Deal"
                name="awardId"
                getOptions={QuestRoute.mobile.deals}
                buildOptions={e => {
                    e.label = e.dealName;
                    e.value = e.awardId;
                }}
                nullable
            />
        </>
    );

    const editAward = award => {
        const id = `edit-award-${award.pointAwardId}`;
        ModalFactory.show({
            id,
            title: `Edit Award`,
            body: (
                <Form
                    inputs={{
                        Description: award.description ?? '',
                        pointCost: award.pointCost ?? '',
                        appProductId: award.appProductId ?? '',
                        awardId: award.awardId ?? '',
                        pointAwardId: award.pointAwardId
                    }}
                    onSubmit={e =>
                        HamQuest.post(
                            QuestRoute.LoyaltyPointAwards.main + "/" + award.pointAwardId,
                            e
                        ).then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text="Update"
                >
                    {({ values }) => <AwardForm values={values} />}
                </Form>
            ),
        });
    };

    const addNewAward = () => {
        const id = `add-award`;
        ModalFactory.show({
            id,
            title: `Create Award`,
            body: (
                <Form
                    inputs={{
                        Description: '',
                        pointCost: ''
                    }}
                    onSubmit={e =>
                        HamQuest.post(
                            QuestRoute.LoyaltyPointAwards.main,
                            e
                        ).then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text="Create"
                >
                    {({ values }) => <AwardForm values={values} />}
                </Form>
            ),
        });
    };

    const deleteAward = award => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${award.description}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Award',
                body: `Deleting ${award.description}`,
                callback: () => HamQuest.delete(QuestRoute.LoyaltyPointAwards.main + "/" + award.pointAwardId),
            },
        confirmed: {
            title: 'Success',
            body: `${award.description} successfully deleted.`,
            type: 'success',
      },
      finally: () => refreshAwards(),
    });
  };

    return (
            <Table
                config={{
                    label: 'Loyalty Point Awards',
                    controls: [
                        <Button key="add" onClick={addNewAward}>
                            Create New Award
                        </Button>
                    ],
                    data: awards,
                    headers: [
                        { label: 'Description', propKey: 'description' },
                        { label: 'Points', propKey: 'pointCost' },
                    ],
                    renderFormat: award => (
                        <ManagementRow
                            key={award.pointAwardId}
                            controls={[
                                <Button key="edit" onClick={() => editAward(award)}>
                                    Edit
                                </Button>,
                                <Button key="del" onClick={() => deleteAward(award)}>
                                    Delete
                                </Button>
                            ]}
                        >
                            <td>{award.description}</td>
                            <td>{award.pointCost}</td>
                        </ManagementRow>
                    ),
                }}
            />
    );
}

export default PointsAwards;